<template>
  <div class="video" :class="modifiers">
    <video
      ref="video"
      :controls="isControlsVisible"
      :muted="muted"
      :poster="preview"
      :loop="isLoop ? 'loop' : false"
      playsinline
      class="video__inner"
      @ended="onVideoEnd"
    >
      <source :src="`${src}${time}`" type="video/mp4">
    </video>
    <div v-if="!isPlaying && autoplay === -1" class="video__mask">
      <button type="button" class="video__button" @click="play">
        <BaseIcon name="play" />
      </button>
    </div>
    <div v-if="description && !isStarted" class="video__description" v-html="description" />
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseVideo',
  components: {
    BaseIcon,
  },
  props: {
    file: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Number,
      default: -1,
    },
    controls: {
      type: [String, Boolean],
      default: 'controls',
    },
    muted: {
      type: [String, Boolean],
      default: false,
    },
    isLoop: {
      type: Boolean,
      default: false,
    },
    poster: {
      type: String,
      default: '',
    },
    isRound: {
      type: Boolean,
      default: false,
    },
    isSquare: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isPlaying: false,
      isStarted: false,
    };
  },
  staticData: () => ({
    timeout: null,
  }),
  computed: {
    src() {
      return require(`@/assets/video/${this.file}`); // eslint-disable-line
    },
    preview() {
      if (!this.poster) return false;
      return require(`@/assets/images/${this.poster}`); // eslint-disable-line
    },
    time() {
      if (this.preview) return '';
      return '#t=0.1';
    },
    modifiers() {
      return {
        video_round: this.isRound,
        video_square: this.isSquare,
      };
    },
    isControlsVisible() {
      // if (this.isStarted) return true;
      if (!this.isStarted && this.description) return false;
      return this.controls;
    },
  },
  mounted() {
    this.tryStart();
  },
  beforeDestroy() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
  },
  methods: {
    play() {
      if (!this.$refs.video) return;
      this.isPlaying = true;
      this.$emit('play');
      this.$refs.video.play();
      this.isStarted = true;
    },
    tryStart() {
      if (this.autoplay < 0) return;
      this.timeout = window.setTimeout(this.play, this.autoplay);
    },
    onVideoEnd() {
      this.$emit('finish');
    },
  },
};
</script>

<style lang="stylus">
.video
  position relative
  display block
  width 100%
  padding 0

  &:before
    content ''
    display block
    padding-top ( 9 / 16 ) * 100%

  &_square
    &:before
      padding-top 100%

  &__inner
    display block
    abs top left right bottom
    width 100%
    height @width
    border 0
    outline none
    //box-shadow 0px 0px 25px rgba(0, 0, 0, 0.25)
    object-fit cover
    z-index 1
    ~/_round &
      border-radius 1em

  &__mask
    abs top left right bottom
    //background-color alpha($c_bright, 25%)
    display flex
    flex-flow row wrap
    align-items center
    justify-content center
    z-index 3

  &__description
    abs bottom left right
    font-weight 700
    line-height 1.2
    color #fff
    background linear-gradient(180deg, alpha(#000, 0), alpha(#000, 50%))
    padding 1em 1.6em
    z-index 2
    ~/_round &
      border-radius 0 0 0.8em 0.8em
    +portrait()
      font-size 0.9em

  &__button
    display block
    width 4em
    height 4em
    padding 0
    border 0
    outline none
    background none
    color #fff
    &:hover
    &:focus
      color alpha(#fff, 85%)
    .icon
      filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.25))
</style>
